import moment from 'moment';

import { isNullOrEmpty } from '../../utilities/stringUtil';
import PrintUtility from '../../utilities/printUtility';

/**
 * CCUS送信履歴取得パラメータ作成
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchCheckInOutLogTransmissionHistories = param => {
  const searchParam = Object.create(null);
  searchParam.offset = param.offset;
  if (!isNullOrEmpty(param.companyId)) {
    searchParam.company_id = Number(param.companyId);
  }
  return searchParam;
};

/**
 * CCUS送信結果エラー情報取得パラメータ作成
 * @param {object}param:パラメーター
 * @return {object}updateParam:API通信用パラメーター
 * */
const createSearchErrorResults = param => {
  const searchParam = Object.create(null);
  searchParam.check_in_out_log_transmission_histories_id = Number(
    param.checkInOutLogTransmissionHistoryId
  );
  searchParam.offset = Number(param.offset);
  searchParam.limit = Number(param.limit);
  return searchParam;
};

/**
 * @description excel出力
 * @param blob blob形式
 * @param fieldId: 現場ID
 */
const downloadExcel = blob => {
  const filename = `顔レコ利用記録_${moment(new Date()).format(
    'YYYYMMDD'
  )}.xlsx`;
  PrintUtility.printBlob(blob, filename);
};

/**
 * ダッシュボードで利用するビジネスロジック格納クラス
 * */
const InOutDashboardService = {
  createSearchCheckInOutLogTransmissionHistories,
  createSearchErrorResults,
  downloadExcel,
};

export default InOutDashboardService;



// WEBPACK FOOTER //
// ./src/services/inOutDashboard/InOutDashboardService.js